var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.7 4.167a.7.7 0 1 0-1.4 0V9.3H4.167a.7.7 0 1 0 0 1.4H9.3v5.133a.7.7 0 1 0 1.4 0V10.7h5.133a.7.7 0 1 0 0-1.4H10.7z",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;